import * as types from '../types';
import { IGLAccountsApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class GLAccountsHttpApi extends HttpApi implements IGLAccountsApi {
  async listGLAccounts(): Promise<types.GLAccount[]> {
    // Backend mounts the GL router at /gl (GET /gl/accounts).
    const response = await this.http.get<types.APIResponse<types.GLAccount[]>>('/gl/accounts');
    return response.data.data;
  }

  async getGLAccount(id: string): Promise<types.GLAccount> {
    const response = await this.http.get<types.APIResponse<types.GLAccount>>(`/gl/accounts/${id}`);
    return response.data.data;
  }

  async createGLAccount(data: types.CreateGLAccountRequest): Promise<types.GLAccount> {
    const response = await this.http.post<types.APIResponse<types.GLAccount>>('/gl/accounts', data);
    return response.data.data;
  }

  async updateGLAccount(id: string, data: types.UpdateGLAccountRequest): Promise<types.GLAccount> {
    const response = await this.http.patch<types.APIResponse<types.GLAccount>>(`/gl/accounts/${id}`, data);
    return response.data.data;
  }

  async seedChartOfAccounts(): Promise<types.SeedChartOfAccountsResponse> {
    const response = await this.http.post<types.APIResponse<types.SeedChartOfAccountsResponse>>('/gl/seed');
    return response.data.data;
  }
}
